export default "__VITE_ASSET__B8E8AizG__"